export default function IconArrowDownSmall () {
  return (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M0.659186 2.01696C0.882772 1.9689 1.1102 2.02466 1.28941 2.16286L1.30264 2.17306L1.35998 2.22373L3.99979 4.87888L6.62829 2.23517C6.78552 2.07705 7.00053 1.9866 7.23065 2.00165C7.45827 2.01653 7.65528 2.13135 7.79027 2.29642L7.79984 2.30811L7.84408 2.36942L7.85192 2.38174C8.06445 2.71571 8.047 3.17243 7.80546 3.48459L7.79608 3.49673L7.74601 3.55383L4.55315 6.76493C4.27586 7.0438 3.84797 7.08304 3.52901 6.83765L3.51566 6.82739L3.45799 6.77649L0.26469 3.56494C-0.0491336 3.24933 -0.0784128 2.7371 0.147727 2.38174C0.261184 2.20345 0.438648 2.06437 0.659186 2.01696Z"
            fill="#85929A"/>
    </svg>

  )
}
